enum PackageLineState {
    Unmodified = 'unmodified',
    ChangedAnchor = 'changedAnchor',
    ChangedLabel = 'changedLabel',
    ChangedManualText = 'changedManualText'
}

export default PackageLineState;
